// @flow
import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/main/'
import { ConnectedRouter, routerMiddleware } from 'connected-react-router'
import createSagaMiddleware from 'redux-saga'
import rootSaga from './sagas'
import { Provider } from 'react-redux'
import { applyMiddleware, compose, createStore } from 'redux'
import createRootReducer from 'stores'
import { createMemoryHistory, createBrowserHistory } from 'history'
import storage from 'redux-persist/lib/storage'
import { persistReducer, persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'
import hardSet from 'redux-persist/es/stateReconciler/hardSet'

const createHistory =
  process.env.NODE_ENV === 'production'
    ? createMemoryHistory
    : createBrowserHistory

const history = createHistory({
  basename: process.env.NODE_ENV === 'production' ? '/2019/populisten-quiz' : ''
})

const sagaMiddleware = createSagaMiddleware()

const persistConfig = {
  // use article ID as key
  key: '22441502',
  storage: storage,
  whitelist: ['answers', 'demographics', 'router'],
  stateReconciler: hardSet
}

// compose alternative according to
// https://github.com/zalmoxisus/redux-devtools-extension#12-advanced-store-setup
// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

/**
 * Configure Store
 * @param {Partial<import('./stores').RootState>} [preloadedState]
 * @returns {*}
 */
const configureStore = preloadedState => {
  return createStore(
    persistReducer(persistConfig, createRootReducer(history)),
    preloadedState,
    composeEnhancers(applyMiddleware(routerMiddleware(history), sagaMiddleware))
  )
}
const store = configureStore()
const persistor = persistStore(store)

// Start root saga
sagaMiddleware.run(rootSaga)

// Render the main component into the dom
const rootElement = document.getElementById('app')

if (rootElement != null) {
  // For the time being we can't take advantage of ReactDOM.hydrate(),
  // as the share buttons use the window.location, which produces wrong
  // attributes in react-snap – which are then not corrected by hydrate()
  ReactDOM.render(
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </PersistGate>
    </Provider>,
    rootElement
  )
}
